export const adTypeOption = [
  { value: "demand", name: "درخواستی" },
  { value: "supply", name: "عرضه" },
];
